import { apiClient } from '~/services/api-service';
import { CreateVideoQrPayload, UpdateVideoQrPayload, Video, VideoQrResponse } from '~/types/video';

export const createVideoQR = async (payload: CreateVideoQrPayload) => {
  const response = await apiClient.post<VideoQrResponse>(`/microsite/video/`, payload);
  return response.data;
};

export const getVideoQRById = (id: number | string) => {
  return apiClient.get<VideoQrResponse>(`/microsite/video/${id}/`);
};

export const updateVideoQR = ({ payload, id }: { payload: UpdateVideoQrPayload; id: number | string }) => {
  return apiClient.patch(`/microsite/video/${id}/`, payload);
};

export const deleteVideoQRVideo = ({
  videoQrId,
  videoId,
}: {
  videoQrId: number | string;
  videoId: number | string;
}) => {
  return apiClient.delete(`/microsite/video/${videoQrId}/videos/${videoId}/`);
};

export const addVideoQRVideo = ({ videoQrId, video }: { videoQrId: number | string; video: Partial<Video> }) => {
  return apiClient.post(`/microsite/video/${videoQrId}/videos/`, video);
};

export const updateVideoQRVideo = ({
  videoQrId,
  videoId,
  payload,
}: {
  videoQrId: number | string;
  videoId: number | string;
  payload: Partial<Video>;
}) => {
  return apiClient.patch(`/microsite/video/${videoQrId}/videos/${videoId}/`, payload);
};
